import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const services = [
    'Market Research & Business Intelligence',
    'Student Support & Mentorship',
    'Business Cases & Corporate Presentations',
    'Startup Pitch Decks',
    'Consulting & AI Roadmaps'
  ];

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-gray-200/50 sticky top-0 z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_7be45cf1-2732-4548-9b9b-de308b396d7f/artifacts/1xjolion_Logo%20Knowledge%20Ninja.PNG" 
              alt="Knowledge Ninja Lab" 
              className="h-10 w-auto transition-transform duration-300 hover:scale-105"
            />
            <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-gray-900 font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">Knowledge Ninja Lab</h1>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-gray-700 hover:text-[#61525a] transition-colors duration-200 font-medium">Home</a>
            <a href="#about" className="text-gray-700 hover:text-[#61525a] transition-colors duration-200 font-medium">About</a>
            <div className="relative group">
              <button 
                className="flex items-center text-gray-700 hover:text-[#61525a] transition-colors duration-200 font-medium"
                onMouseEnter={() => setIsServicesOpen(true)}
                onMouseLeave={() => setIsServicesOpen(false)}
              >
                Services
                <ChevronDown className="ml-1 w-4 h-4 transition-transform duration-200 group-hover:rotate-180" />
              </button>
              {isServicesOpen && (
                <div 
                  className="absolute top-full left-0 mt-2 w-80 bg-white rounded-lg shadow-xl border border-gray-100 py-2 z-50"
                  onMouseEnter={() => setIsServicesOpen(true)}
                  onMouseLeave={() => setIsServicesOpen(false)}
                >
                  {services.map((service, index) => (
                    <a
                      key={index}
                      href="#services"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsServicesOpen(false);
                        document.getElementById('services').scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#61525a] transition-colors duration-200"
                    >
                      {service}
                    </a>
                  ))}
                </div>
              )}
            </div>
            <a href="#careers" className="text-gray-700 hover:text-[#61525a] transition-colors duration-200 font-medium">Careers</a>
            <a href="#contact" className="text-gray-700 hover:text-[#61525a] transition-colors duration-200 font-medium">Contact</a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              className="bg-[#61525a] hover:bg-[#4a3f47] text-white px-6 py-2 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg font-medium"
              onClick={() => document.getElementById('booking-form').scrollIntoView({ behavior: 'smooth' })}
            >
              Book Service Inquiry
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-[#61525a] hover:bg-gray-100 transition-colors duration-200"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="#home" className="block px-3 py-2 text-gray-700 hover:text-[#61525a] hover:bg-gray-50 rounded-md transition-colors duration-200">Home</a>
              <a href="#about" className="block px-3 py-2 text-gray-700 hover:text-[#61525a] hover:bg-gray-50 rounded-md transition-colors duration-200">About</a>
              <div className="px-3 py-2">
                <div className="text-gray-700 font-medium mb-2">Services</div>
                {services.map((service, index) => (
                  <a
                    key={index}
                    href="#services"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsMenuOpen(false);
                      document.getElementById('services').scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="block px-2 py-1 text-sm text-gray-600 hover:text-[#61525a] hover:bg-gray-50 rounded transition-colors duration-200"
                  >
                    {service}
                  </a>
                ))}
              </div>
              <a href="#careers" className="block px-3 py-2 text-gray-700 hover:text-[#61525a] hover:bg-gray-50 rounded-md transition-colors duration-200">Careers</a>
              <a href="#contact" className="block px-3 py-2 text-gray-700 hover:text-[#61525a] hover:bg-gray-50 rounded-md transition-colors duration-200">Contact</a>
              <div className="px-3 py-2">
                <Button 
                  className="w-full bg-[#61525a] hover:bg-[#4a3f47] text-white px-4 py-2 rounded-lg transition-all duration-300 font-medium"
                  onClick={() => {
                    setIsMenuOpen(false);
                    document.getElementById('booking-form').scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  Book Service Inquiry
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export { Header };